import baseInputMetadata from './baseInputMetadata'

export default baseInputMetadata
